import { HeaderColumn, HelpTable } from './helpTable';
import { Title } from '../../basic/help/title';
import { Image } from '../../basic/help/image';
import { Link } from '../../basic/link';
import { Text } from '../../basic/help/text';

import ScenarioSettingImg1 from '../../../img/manual/scenarioSetting/scenarioSettingImg1.svg';

type scenarioSettingColumn = {
  item: string;
  description: string;
};

const headerColumns: HeaderColumn<scenarioSettingColumn>[] = [
  { id: '1', key: 'item', name: '項目', width: 25 },
  { id: '2', key: 'description', name: '説明', width: 75 },
];

export const dataList: scenarioSettingColumn[] = [
  {
    item: '連携先URL',
    description: `連携先のURLを設定する項目です。 
    RICOH Chatbot Service アプリ連携 管理サイトの設定画面でコピーした連携先URLを使用してください。`,
  },
  {
    item: 'メソッド種類',
    description: `POSTを選択してください。`,
  },
  {
    item: 'リクエストヘッダー',
    description: `連携先へリクエストを送信する際のヘッダー情報を設定する項目です。
    RICOH Chatbot Service アプリ連携 管理サイトの設定画面でコピーしたexecute-Keyを使用してください。`,
  },
  {
    item: 'リクエストボディ',
    description: `連携先へリクエストを送信する際のボディ情報を設定する項目です。
    ボディ情報はJSON形式で入力してください。`,
  },
  {
    item: 'レスポンスボディ',
    description: `連携先からのレスポンス情報をチャットボットで使用するための設定項目です。
    変換元キー名にはチャットボットに表示したいJSONPathを設定してください。
    JSONPathについては下記の使い方ガイドをご確認ください。`,
  },
];

export const ScenarioSetting = () => {
  return (
    <div>
      <Title>RICOH Chatbot Serviceのシナリオ設定</Title>
      <Text>
        RICOH Chatbot Service アプリ連携は、RICOH Chatbot ServiceからAPI連携を受けることができます。
        <br />
        連携内容はRICOH Chatbot Serviceのカスタムシナリオから設定することが可能です。
      </Text>
      <Text>
        カスタムシナリオでAPI連携の内容を設定する画面が以下になります。
      </Text>
      <Image src={ScenarioSettingImg1} alt="scenarioSetting1" width={55} />

      {/* テーブル表示部分 */}
      <HelpTable
        header={headerColumns}
        body={dataList}
        id="scenarioSetting"
        width={95}
      />

      <Text>
        RICOH Chatbot Serviceのシナリオ設定についてさらに詳しい情報が知りたい場合は、
        <Link
          url={`${process.env.REACT_APP_RCHATBOT_SERVICE_GUIDE_URL}`}
          target={'_blank'}
        >
          使い方ガイド
        </Link>
        をご確認ください。
      </Text>
    </div>
  );
};
